<template>
  <div class="taskPage">
    <!--<h2>{{ data.tasks[task].label }}</h2>-->
    <input type="text" v-model="label" v-on:blur="updateLabel">
    <!--<ErranditeInput v-bind:data="data.tasks[task]" field="label" type="text" icon="envelope" label="Label"/>-->
    <!--<h2>
      <ErranditeIcon icon="calendar-alt"/>Dates
    </h2>-->
	<div v-if="data.tasks[task].tasks.length == 0">
		<div class="modes">
			<span v-bind:class="{active: mode}" v-on:click="mode = true">
				<ErranditeIcon icon="calendar-week"/>Start and end dates
			</span>
			<span v-bind:class="{active: !mode}" v-on:click="mode = false">
				<ErranditeIcon icon="calendar-day"/>Due date
			</span>
		</div>
		<v-date-picker v-if="mode == true" mode="range" v-model="range" color="green" is-dark is-inline is-expanded/>
		<v-date-picker v-if="mode == false" v-model="date" color="green" is-dark is-inline is-expanded/>

		<div class="modes">
			<span v-bind:class="{active: !timeActive}" v-on:click="timeActive = false">
				<ErranditeIcon icon="calendar-alt"/>Date only
			</span>
			<span v-bind:class="{active: timeActive}" v-on:click="timeActive = true">
				<ErranditeIcon icon="clock"/>Date and time
			</span>
		</div>
		<input v-if="timeActive" type="time" v-model="timeValue" v-on:change="updateTime" v-on:blur="updateTime"/>
	</div>
	<div v-if="data.tasks[task].tasks.length > 0">
		<span v-for="(colour, idx) in state.colours" v-bind:key="idx" class="colour" v-on:click="setColour(colour)" v-bind:class="{active: data.tasks[task].colour == colour}" v-bind:style="{'background-color': colour}"></span>
	</div>
  </div>
</template>

<script>
import ErranditeIcon from "./ErranditeIcon.vue";
import { tasksCollection } from "./firebase";

import dayjs from "dayjs";

export default {
  name: "ErranditeTaskPage",
  props: {
    task: String,
    state: Object,
    data: Object
  },
  data: function() {
    var rangeMode = false;

    if (this.data.tasks[this.task].start != null) {
      rangeMode = true;
	}
	
	var endTime = "12:00";
	if (this.data.tasks[this.task].end != null) {
		var end = dayjs(this.data.tasks[this.task].end);
		endTime = end.format("HH:mm");
	}
	
    return {
      mode: rangeMode,
      label: this.data.tasks[this.task].label,
      range: {
        start: this.data.tasks[this.task].start,
        end: this.data.tasks[this.task].end
      },
	  date: this.data.tasks[this.task].end,
	  timeValue: endTime,
	  timeActive: this.data.tasks[this.task].time
    };
  },
  components: {
    ErranditeIcon
  },
  methods: {
    updateLabel: function() {
      this.data.tasks[this.task].label = this.label;
	},
	updateTime: function() {
		console.log(this.timeValue);
		this.data.tasks[this.task].end.setHours(Number(this.timeValue.split(":")[0]), Number(this.timeValue.split(":")[1]));
		console.log(this.data.tasks[this.task].end);
		this.$set(this.data.tasks[this.task], "time", true);
	},
	updateDate: function() {
		if (this.mode == true) {
			if (this.range == null) {
				this.data.tasks[this.task].start = null;
				this.data.tasks[this.task].end = null;
				this.date = null;
			} else {
          		this.data.tasks[this.task].start = this.range.start;
				this.data.tasks[this.task].end = this.range.end;
				this.date = null;
			}
        } else {
			this.data.tasks[this.task].start = null;
			this.data.tasks[this.task].end = this.date;
			this.range.start = null;
			this.range.end = null;
        }
	},
	setColour: function(colour) {
		console.log(colour);
		this.$set(this.data.tasks[this.task], "colour", colour);
	}
  },
  watch: {
    range: {
      deep: true,
      handler: function() {
        this.updateDate();
      }
	},
	date: {
      deep: true,
      handler: function() {
        this.updateDate();
      }
	},
	timeActive: function() {
		this.data.tasks[this.task].time = this.timeActive;
	},
    "data.tasks": {
      deep: true,
      handler: function() {
        console.log(this.data.tasks[this.task]);
        var docRef = tasksCollection.doc(this.task);
        docRef.set(this.data.tasks[this.task]).then(function() {
          console.log("Saved changes");
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../styles/_variables.scss";

.taskPage {
  padding: $padding;

  input {
	  padding: $padding;
	  margin-bottom: $padding/2;
  }

  .vc-container {
	  background: transparent;
	  border: 0px;
	  border-radius: $borderRadius;
	  background-color: $dark2;
	  margin-bottom: $padding/2;
  }
}

.modes {
  border-radius: $borderRadius;
  margin-bottom: $padding/2;
  background-color: $dark2;
  display: flex;
  justify-content: stretch;

  span {
    display: inline-block;
    padding: $padding/4;
    border-radius: $borderRadius;
    flex: 1 1 auto;
	text-align: center;
	height: 30px;

    .icon {
      margin-right: $padding/4;
    }
    &.active {
      background-color: $highlight;
    }
  }
}

.colour {
	width: $borderRadius*2 - 4px;
	height: $borderRadius*2 - 4px;
	border-radius: $borderRadius;
	margin-right: $padding/4;
	border: 2px solid $dark2;
	display: inline-block;

	&.active {
		border-color: $white;
	}
}
</style>
